<template>
  <div v-if="callFetchApi && shouldVisible" :falseProp="isLottieCompleted">
    <generic-modal
      height="100vh"
      width="100vw"
      padding="0"
      v-if="showSplashScreenPage"
    >
      <template v-slot:header> </template>
      <template v-slot:body>
        <div class="img" v-if="!showSplashScreen">
          <div class="jfl-loader-container">
            <div class="jfl-loader"></div>
          </div>
        </div>
        <div v-else ref="lottiePlayer">
          <VueLottiePlayer
            v-if="showLottie"
            name="nudgeLottie"
            class="splashLottie ovf-hidden"
            width="100%"
            height="100vh"
            :animationData="lottieUrl"
            :autoplay="false"
            @animControl="(anim) => (lottieConfetti = anim)"
          />
          <lazy-image
              v-else
              alt="splash image"
              :src="imgUrl"
              :src-placeholder="getPlaceHolderImg"
              style="width: 100%; height: 100vh"
            />
        </div>
      </template>
      <template v-slot:footer> </template>
    </generic-modal>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import Utility from "../helpers/utility";
import { keyMapsAction, keyMapsMutation, keyMapsGetter} from "../helpers/storeKeys";
import GenericModal from "./GenericModal.vue";
import { defineAsyncComponent } from "vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import PageNames from "../config/pageNames";
import { staticImgBaseUrl } from "../config/apiEndpoints";

export default {
  name: "DynamicApiWidgetNoUi",
  props: ["dataApi", "moduleProps"],
  components: {
    GenericModal,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  data() {
    return {
      modulePropsData: {},
      shouldVisible: true,
      isStaticWidgetApi: false,
      showLottie: true,
      showSplashScreen: false,
      lottieUrl: "",
      lottieConfetti: null,
      lottiePlayFlag: false,
      showSplashScreenPage: true,
      resolveHomePagePromise: null,
      imgUrl: "",
      flagForHomePagePromise: false,
      homePageFlag: false,
    };
  },
  async mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const cmsFlagForSplashScreen =
      window._siteProps_?.props?.splashScreen === "true";

    let apiCallAndSplashFlag = false;
    const loginFlow =
      LocalStorageFunc.getSessionStorageValuePwaV2Keys("LOGIN_FLOW_SKIP");
    const origin = window.location.origin;
    if (
      !document.referrer ||
      document.referrer == origin ||
      document.referrer == origin + "/" ||
      (document.referrer == origin + "/jfl-discovery-ui/en/pwa/" &&
        loginFlow != true)
    ) {
      apiCallAndSplashFlag = true;
    }

    const splashFlagInSession =
      (sessionStorage["splashFlag"] &&
        LocalStorageFunc.getSessionStorageKey("splashFlag")) ||
      false;

    if (this.homePageFlag && cmsFlagForSplashScreen && !splashFlagInSession && apiCallAndSplashFlag) {
      try {
        document.body.classList.add("body-stop-scroll-mobile");

        const cachedLottieUrl = LocalStorageFunc.getSplashLottieiUrl();
        const cachedLottieJson = LocalStorageFunc.getSplashLottieiJson();  
        const cachedImageUrl = LocalStorageFunc.getSplashImageUrl();
        const cachedImageTimer = LocalStorageFunc.getSplashImageTimer();
        let cachedFlowFlag = false;

        if(cachedLottieUrl && cachedLottieJson){
          this.showSplashScreen = true;
          this.lottieUrl = cachedLottieJson;
          this.showLottie = true;
          cachedFlowFlag = true;
          this.fetchDataFromSplashAPI(cachedFlowFlag);
        }
        else if(cachedImageUrl){
          this.showSplashScreen = true;
          cachedFlowFlag = true;
          this.imgUrl = cachedImageUrl;
          this.showLottie = false;
          this.fetchDataFromSplashAPI(cachedFlowFlag);
          await this.promiseForImage(cachedImageTimer);
          LocalStorageFunc.setSessionStorageKey("splashFlag", true);
          this.resolveHomePagePromise(
            "homepage resume promise resolved- via image timer - cached"
          );
          this.showSplashScreenPage = false;
          document.body.classList.remove("body-stop-scroll-mobile");
        }

        if(!cachedFlowFlag){
      
          const {
            error = "",
            apiSuccess = "",
            data = "",
            isLottie = "",
            timeOut = 0,
          } = await this.fetchDataFromSplashAPI(cachedFlowFlag);

          if (!apiSuccess) {
            this.showSplashScreenPage = false;
            document.body.classList.remove("body-stop-scroll-mobile");
          } else {
            if (data) {
              this.showSplashScreen = true;
              if (isLottie) {
                this.lottieUrl = data;
                this.showLottie = true;
              } else {
                this.imgUrl = data;
                this.showLottie = false;
                await this.promiseForImage(timeOut);
                LocalStorageFunc.setSessionStorageKey("splashFlag", true);
                this.resolveHomePagePromise(
                  "homepage resume promise resolved- via image timer"
                );
                this.showSplashScreenPage = false;
                document.body.classList.remove("body-stop-scroll-mobile");
              }
            }
          }
          
        }
      } catch (error) {
        document.body.classList.remove("body-stop-scroll-mobile");
        console.log("error - ", error);
        this.resolveHomePagePromise(
          "homepage resume promise resolved- via catch " + error
        );
        this.showSplashScreenPage = false;
        LocalStorageFunc.setSessionStorageKey("splashFlag", true);
      }
    } else {
      if (this.homePageFlag) {
        this.resolveHomePagePromise("homepage resume promise resolved");
        document.body.classList.remove("body-stop-scroll-mobile");
      }
      this.showSplashScreenPage = false;
    }
  },
  methods: {
    fetchDataFromAPI() {
      let pageName = Utility.getCurrentStoreFolder();
      if (pageName) {
        if (pageName.includes("menu")) {
          pageName = "Menu";
        } else {
          pageName = "home";
        }
      }

      let apiEndpoint = this.dataApi;
      if (
        apiEndpoint !== undefined &&
        apiEndpoint !== "undefined" &&
        apiEndpoint !== null &&
        apiEndpoint !== "null" &&
        apiEndpoint != false
      ) {
        let apiPayload = {
          endPoint: apiEndpoint.split("?")[0],
          site: window?._siteProps_?.siteContext
            ? (window?._siteProps_?.siteContext).toLowerCase()
            : "jflcms",
          lang: "en",
          platform: window?._siteProps_?.platform
            ? (window?._siteProps_?.platform).toLowerCase()
            : "pwa",
          page: pageName,
          deliveryType: this.currentOrderType,
        };
        this.$store.dispatch(keyMapsAction.STATIC_WIDGET_API, apiPayload);
      }
    },
    promiseForImage(timer) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve("Image timeout completed");
        }, timer * 1000);
      });
    },
    fetchDataFromSplashAPI(cachedFlowFlag = false) {
      const pageName = "launch";
      let apiPayload = {
        site: window?._siteProps_?.siteContext
          ? (window?._siteProps_?.siteContext).toLowerCase()
          : "jflcms",
        lang: "en",
        platform: window?._siteProps_?.platform
          ? (window?._siteProps_?.platform).toLowerCase()
          : "pwa",
        page: pageName,
        deliveryType: this.currentOrderType,
        cachedFlowFlag: cachedFlowFlag
      };

      const promiseForSplashScreen = this.$store.dispatch(
        keyMapsAction.GET_SPLASH_SCREEN_DATA,
        apiPayload
      );
      return promiseForSplashScreen;
    },
    setFullscreenViewBox(){
      const container = this.$refs.lottiePlayer;
      const svgElement = container.querySelector("svg");

      if (svgElement) {
        svgElement.setAttribute("preserveAspectRatio", `none`);
      }

      const imgEle = container.querySelector("svg .png image");
      if(imgEle){
        imgEle.setAttribute("preserveAspectRatio", `none`);
      }


    },
  },
  computed: {
    callFetchApi() {
      if (!this.flagForHomePagePromise) {
        this.flagForHomePagePromise = true;

        const linkRewrite = Utility.getLinkRewriteFromSiteprops();
        if (
          linkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME ||
          linkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
        ) {
          this.homePageFlag = true;
        }

        if (this.homePageFlag) {
          const homepageCodeResumePromise = new Promise((resolve, reject) => {
            this.resolveHomePagePromise = resolve;
          });

          this.$store.commit(
            keyMapsMutation.UPDATE_PROMISE_FOR_SPLASH_SCREEN,
            homepageCodeResumePromise
          );
        }
      }
      const orderType = this.$store.state.User.currentOrderType;
      if (orderType && !this.isStaticWidgetApi) {
        this.isStaticWidgetApi = true;
        this.fetchDataFromAPI();
      }

      return true;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    isLottieCompleted() {
      let lottie = this.lottieConfetti;
      if (lottie && !this.lottiePlayFlag) {
        this.setFullscreenViewBox();
        this.lottiePlayFlag = true;

        this.lottieConfetti.addEventListener("DOMLoaded", () => {
          try{
            this.lottieConfetti.play();
          }
          catch(error){
            console.log("error from isLottieCompleted -", error);
            this.resolveHomePagePromise(
              "homepage resume promise resolved- via lottie play catch"
            );

            this.showSplashScreenPage = false;
            document.body.classList.remove("body-stop-scroll-mobile");
            LocalStorageFunc.setSessionStorageKey("splashFlag", true);
          }
        });

        this.lottieConfetti.addEventListener("complete", () => {
          this.resolveHomePagePromise(
            "homepage resume promise resolved- via lottie complete"
          );
          this.showSplashScreenPage = false;
          document.body.classList.remove("body-stop-scroll-mobile");
          LocalStorageFunc.setSessionStorageKey("splashFlag", true);
        });
      }
      return lottie;
    },
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
  },
};
</script>
